export const splitString = (string) => {
  let result = ''
  for (let i = 0; i < string.length; i++) {
    if (Number(string[i]) || Number(string[i]) === 0) {
      result += string[i]
    }
  }
  return +result
}
